import keycloak from '@/platform/auth/services/keycloak';

// SPA-lifetime singletons — one keycloak adapter, so one timer and one listener.
let refreshTimer: ReturnType<typeof setTimeout> | null = null;
let visibilityListenerAdded = false;
let onRefreshFailure: (() => void) | null = null;

function clearRefreshTimer() {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
}

function scheduleRefresh() {
  clearRefreshTimer();
  const tokenExp = keycloak.tokenParsed?.exp ?? 0;
  const now = Math.floor(Date.now() / 1000);
  const refreshTime = tokenExp - now - 30; // 30s before expiry
  if (refreshTime > 0) {
    refreshTimer = setTimeout(async () => {
      try {
        await refreshAndSync(30);
      } catch (error) {
        console.error('Token refresh failed:', error);
        onRefreshFailure?.();
      }
    }, refreshTime * 1000);
  }
}

async function refreshAndSync(minValidity: number): Promise<boolean> {
  const refreshed = await keycloak.updateToken(minValidity);
  if (refreshed && keycloak.token) {
    scheduleRefresh();
  }
  return refreshed;
}

async function handleVisibilityChange() {
  if (!document.hidden && keycloak.authenticated) {
    try {
      await refreshAndSync(70);
    } catch (error) {
      console.warn('Token refresh on visibility change failed:', error);
    }
  }
}

export function startRefreshLifecycle(onFailure: () => void) {
  onRefreshFailure = onFailure;
  if (!visibilityListenerAdded) {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    visibilityListenerAdded = true;
  }
  scheduleRefresh();
}

export async function refreshNow(minValidity: number): Promise<boolean> {
  return refreshAndSync(minValidity);
}

// Visibility listener stays installed; nothing else holds the timer.
export function stopRefresh() {
  clearRefreshTimer();
}
